
import { Component, Vue } from 'vue-property-decorator';
import { GdbState } from '@/state/gdbq';
@Component({
	components: {},
})
export default class GdbView extends Vue {
	public data: string = '';

	public created() {
		const gdbq: GdbState = new GdbState(this);
	}
}
